export default __webpack_public_path__ + "static/worldometer-a16513bc779fdb71b4933a43a0206fea.png";